// extracted by mini-css-extract-plugin
export default {"stepFooter":"stepFooter-wz3CY"};